module.exports = __webpack_public_path__ + "img/code.1428c77d.png";